import { createContext, useContext, useState } from 'react';

const displayContext = createContext();

export const DisplayProvider = ({ children }) => {
    const [displayY1, setY1] = useState(false);
    const [displayY2, setY2] = useState(false);
    const [displayY3, setY3] = useState(false);
    const [displayAverage, setAv] = useState(false);
  
    return (
      <displayContext.Provider value={{ displayY1, setY1, displayY2, setY2, displayY3, setY3, displayAverage, setAv }}>
        {children}
      </displayContext.Provider>
    )
  }
  
export const useDisplay = () => {
const { displayY1, setY1, displayY2, setY2, displayY3, setY3, displayAverage, setAv } = useContext(displayContext)
return { displayY1, setY1, displayY2, setY2, displayY3, setY3, displayAverage, setAv }
}